/**
 * Gabarits DTS officiels épurés (CNSS, CNAMGS), embarqués dans le build.
 *
 * Les classeurs vivent dans `src/assets/dts-gabarits/` et sont importés en `?inline`
 * (data-URI base64) : ils sont donc dans le JavaScript empaqueté (`dist/**`, donc dans l'asar
 * electron-builder) et se lisent sans `fetch` — `fetch` est indisponible sous `file://` (Electron)
 * et `connect-src` ne l'autorise pas. Chargement paresseux : les ~40 Ko ne pèsent qu'au premier export.
 *
 * Les gabarits ne contiennent AUCUNE donnée d'exemple ni donnée personnelle (voir
 * `tests/unit/infrastructure/DtsGabarits.test.ts`).
 */

export type TypeGabaritDts = 'cnss' | 'cnamgs';

const PREFIXE_BASE64 = ';base64,';

function dataUriVersArrayBuffer(uri: string): ArrayBuffer {
  const idx = uri.indexOf(PREFIXE_BASE64);
  if (!uri.startsWith('data:') || idx < 0) {
    throw new Error('Gabarit DTS illisible : format de ressource inattendu');
  }
  const binaire = atob(uri.slice(idx + PREFIXE_BASE64.length));
  const out = new ArrayBuffer(binaire.length);
  const octets = new Uint8Array(out);
  for (let i = 0; i < binaire.length; i += 1) octets[i] = binaire.charCodeAt(i);
  return out;
}

/** Octets du gabarit officiel épuré (copie autonome, modifiable par l'appelant). */
export async function chargerGabaritDts(type: TypeGabaritDts): Promise<ArrayBuffer> {
  const mod =
    type === 'cnss'
      ? await import('../../assets/dts-gabarits/gabarit_DTS_CNSS.xlsx?inline')
      : await import('../../assets/dts-gabarits/gabarit_DTS_CNAMGS.xlsx?inline');
  return dataUriVersArrayBuffer(mod.default);
}
